let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8cbTQ")).then(() => parcelRequire('9hohk'));